import React, { useState, useEffect } from 'react'
import { LinkPreview } from '../shared/LinkPreview'
import useStore from 'state/knovStore'
import styles from './twitterSuccess.module.scss'
import cn from 'classnames'

export default function TwitterSuccess({ modalParams, closeModal }) {
    const { tweet_url, tweet_count, provider_username } = modalParams
    const [showLinkPreview, setShowLinkPreview] = useState(false)

    // Show link preview after a brief delay for a nicer animation
    useEffect(() => {
        const timer = setTimeout(() => setShowLinkPreview(true), 300)
        return () => clearTimeout(timer)
    }, [])

    const handleViewOnTwitter = () => {
        window.open(tweet_url, '_blank', 'noopener,noreferrer')
    }

    return (
        <div className={styles.twitterSuccessComp}>
            <div className={styles.header}>
                <h2 className={styles.title}>🎉 Thread Posted Successfully!</h2>
            </div>

            <div className={styles.content}>
                <p className={styles.message}>
                    Your thread has been posted to Twitter as {tweet_count} tweet
                    {tweet_count > 1 ? 's' : ''}.
                </p>

                {showLinkPreview && tweet_url && (
                    <div className={styles.previewContainer}>
                        <LinkPreview
                            url={tweet_url}
                            domain="twitter.com"
                            onMouseEnterAnswer={() => {}}
                            onMouseLeaveAnswer={() => {}}
                        />
                    </div>
                )}

                <div className={styles.actions}>
                    <button
                        onClick={handleViewOnTwitter}
                        className={cn(styles.button, styles.primaryButton)}
                    >
                        <i className="fa fa-twitter" />
                        View on Twitter
                    </button>
                    <button
                        onClick={closeModal}
                        className={cn(styles.button, styles.secondaryButton)}
                    >
                        Done
                    </button>
                </div>
            </div>
        </div>
    )
}
